/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_SubmenuInputs */

const en_text_submenu = /** @type {(inputs: Text_SubmenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text formatting submenu`)
};

const fr_text_submenu = /** @type {(inputs: Text_SubmenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-menu de formatage du texte`)
};

const de_text_submenu = /** @type {(inputs: Text_SubmenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untermenü „Textformatierung“`)
};

const it_text_submenu = /** @type {(inputs: Text_SubmenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottomenu di formattazione del testo`)
};

const ru_text_submenu = /** @type {(inputs: Text_SubmenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подменю форматирования текста`)
};

const es_text_submenu = /** @type {(inputs: Text_SubmenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submenú de formato de texto`)
};

const zh_cn2_text_submenu = /** @type {(inputs: Text_SubmenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本格式子菜单`)
};

const ja_text_submenu = /** @type {(inputs: Text_SubmenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキスト書式設定サブメニュー`)
};

const hi_text_submenu = /** @type {(inputs: Text_SubmenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट फ़ॉर्मेटिंग सबमेनू`)
};

const pt_pt2_text_submenu = /** @type {(inputs: Text_SubmenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submenu de formatação de texto`)
};

/**
* | output |
* | --- |
* | "Text formatting submenu" |
*
* @param {Text_SubmenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_submenu = /** @type {((inputs?: Text_SubmenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_SubmenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_text_submenu(inputs)
	if (locale === "de") return de_text_submenu(inputs)
	if (locale === "it") return it_text_submenu(inputs)
	if (locale === "ru") return ru_text_submenu(inputs)
	if (locale === "es") return es_text_submenu(inputs)
	if (locale === "zh-CN") return zh_cn2_text_submenu(inputs)
	if (locale === "ja") return ja_text_submenu(inputs)
	if (locale === "hi") return hi_text_submenu(inputs)
	if (locale === "pt-PT") return pt_pt2_text_submenu(inputs)
	return en_text_submenu(inputs)
});